import { useNavigate, useParams } from 'react-router-dom'
import { useGetQuery, usePostQuery } from 'hooks'
import { Card, Title } from 'components'
import { DungeonAdminForm } from './form'
import { DungeonNpcPlacements } from './npc-placements'

export const AdminDungeonEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data, isFetching } = useGetQuery({ url: `/admin/dungeons/${id}` })
  const { post: updateDungeon } = usePostQuery({ url: `/admin/dungeons/${id}`, method: 'PUT' })
  const dungeon = data?.dungeon

  const handleSubmit = async (payload) => {
    await updateDungeon(payload)
    navigate('/admin/dungeons')
  }

  if (isFetching || !dungeon) return null

  return (
    <Card margin="0.5rem">
      <Title level={3} color="link">{dungeon.name}</Title>
      <DungeonAdminForm
        initial={dungeon}
        onSubmit={handleSubmit}
        submitLabel="Save Changes"
      />
      <DungeonNpcPlacements dungeonId={dungeon.id} />
    </Card>
  )
}
